import './App.css';
import * as React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import LandingPage from './club-vip/pages/LandingPage.tsx';
import LoginPage from './club-vip/pages/LoginPage.tsx';
import ContactFormPage from './club-vip/pages/ContactFormPage.tsx';
import RegisterPage from './club-vip/pages/RegisterPage.tsx';
import RestablecerContraseña from './club-vip/pages/ResetPassword.tsx';
import UserPage from './club-vip/pages/UserPage.tsx';
import AdminPage from './club-vip/pages/AdminPage.tsx';
import DetailPid from './club-vip/components/club-vip/components/carouseles/pages/detailPidPage.tsx';
import DetailCid from './club-vip/components/club-vip/components/carouseles/pages/detailCidPage.tsx';
import { Status } from '@googlemaps/react-wrapper';
import {store} from './club-vip/store.ts'
import { Provider } from 'react-redux'
import EditMarker from './club-vip/pages/EditMarker.tsx';
import { options } from '@config';
import ProtectedRoute, { ProtectedRouteAdmin } from './middlewares/ProtectedRoute.tsx'
import CredentialValidator from './club-vip/components/user-view/components/credential/credentialValidator.tsx';



function App() {
  window.apikeyGoogle = `https://maps.googleapis.com/maps/api/js?v=beta&amp;key=${options.map.mapApiKey}&amp;&amp;loading=async&amp;&amp;libraries=marker,places&amp;language=es&amp;&amp;`
  const render = (status: Status) => (<h1>{status}</h1>)
  return (
    <Provider store={store}>
      <div className="App">
        {/* <script
          src={window.apikeyGoogle}>
        </script> */}

        <BrowserRouter>
          <Routes>
            <Route path={"/"} element={<LandingPage />} />
            <Route path={"/registrarse"} element={<RegisterPage />} />
            <Route path={"/login"} element={<LoginPage />} />
            <Route path={"/categoria/:cid"} element={<DetailCid />}/>
            <Route path={"/categoria/:cid/:pid"} element={<DetailPid />}/>
            <Route path={"/notificaciones/:pid"} element={<DetailPid />}/>
            <Route path={"/contact"} element={<ContactFormPage />} />
            <Route path={"/user"} element={<ProtectedRoute><UserPage /></ProtectedRoute>} />
            <Route path={"/admin"} element={<ProtectedRouteAdmin><AdminPage /></ProtectedRouteAdmin>} />
            <Route path={"/admin/marker/:mid"} element={<ProtectedRouteAdmin><EditMarker /></ProtectedRouteAdmin>} />
            <Route path={"/verify/:userid"} element={<CredentialValidator />} />
            <Route path={"/reset-password/:user/:token"} element={<RestablecerContraseña />} />
            <Route path={"*"} />
          </Routes>  
        </BrowserRouter>
      </div>
    </Provider>
  );
}


export default App;